import React from 'react';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { createOpenAIModalCommand } from '../../../../pm-plugins/decoration/actions';
import { getTranslatedItemTitle } from '../config-items';
export function mapConfigItemsToQuickInsertItems(_ref) {
  var configItems = _ref.configItems,
    formatMessage = _ref.formatMessage,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    editorView = _ref.editorView;
  var aiPriorities = 9000;
  var dispatch = editorView.dispatch;
  return configItems.map(function (configItem) {
    var _configItem$quickInse;
    return {
      priority: (_configItem$quickInse = configItem.quickInsertPriority) !== null && _configItem$quickInse !== void 0 ? _configItem$quickInse : aiPriorities,
      categories: ['AI'],
      title: getTranslatedItemTitle(configItem, formatMessage),
      description: formatMessage(configItem.description || configItem.title),
      keywords: ['ai', 'generate', getTranslatedItemTitle(configItem, formatMessage)],
      icon: function icon() {
        return configItem.icon ? configItem.icon({
          formatMessage: formatMessage
        }) : /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
          label: "",
          spacing: "spacious"
        });
      },
      action: function action(insert, editorState) {
        // We set the openAIModalCommand to run on the next tick -- as it then
        // performs additional transactions to update the document

        requestAnimationFrame(function () {
          var openAIModalCommand = createOpenAIModalCommand({
            state: editorView.state,
            configItem: configItem,
            lastTriggeredFrom: 'quickInsert',
            aiGlobalOptIn: aiGlobalOptIn
          });
          openAIModalCommand(editorView.state, dispatch);
        });

        // Insert empty string to remove the typeahead raw text
        // close the quick insert immediately
        var transaction = insert('');
        return transaction;
      },
      isDisabledOffline: true
    };
  });
}